import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import GoogleLogo from '@ro-atoms/GoogleLogo';
import MapTarget from '@ro-components/MapTarget';
import { dispatch } from '@ro-store';
import { asString, setDataFromUrl } from '@ro-utils/common/helpers';

class MapContainer extends Component {
  componentDidMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      if (action === 'POP') {
        setDataFromUrl(location, dispatch, this.props.queryString);
      }
    });
  }
  shouldComponentUpdate(nextProps) {
    const { date } = this.props;
    const { date: nextDate } = nextProps;
    if (asString(date) === asString(nextDate)) {
      return false;
    }
  }
  componentWillUnmount() {
    this.unlisten();
  }
  render() {
    const { tile } = this.props;
    return (
      <Fragment>
        <MapTarget firstLoad />
        {tile.match('Google') ? <GoogleLogo /> : null}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ ro }) => ({
  tile: ro.userSettings.tile,
  queryString: ro.queryString
});

export default withRouter(connect(mapStateToProps)(MapContainer));
